export const reducerCloseChatbox = (state, { chatId }) => ({
  ...state,
  chatboxes: state.chatboxes.filter(
    ({ id }) => id !== chatId
  ),
})
